import React from 'react';
import HeaderText from '../../Common/HeaderText';

const MyMvpsHeader = () => {
  return (
    <div className='flex flex-col max-w-[868px] w-full items-start'>
      <HeaderText label={'My Q&A'} />
    </div>
  );
};

export default MyMvpsHeader;
